import './manage-subscription.css';
import { Button, CircularProgress } from '@material-ui/core';
import React, { useState } from 'react';
import { posthog } from 'posthog';
import { setMessages } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
import { cancelSubscription } from 'store/sagas/sagas';
import { isSelfServiceAccount } from 'utils/billing';
export const ManageSubscription = () => {
    const { state, dispatch, asyncDispatch } = useGlobalState();
    const [isLoading, setIsLoading] = useState(false);
    const submitCancelSubscription = (event) => {
        event.preventDefault();
        setIsLoading(true);
        asyncDispatch(cancelSubscription())
            .then(() => {
            posthog.capture('subscription_cancelled');
            dispatch(setMessages({
                severity: 'success',
                value: `Your subscription has been canceled`
            }));
        })
            .catch(console.error)
            .finally(() => {
            setIsLoading(false);
        });
    };
    return (React.createElement("div", { className: "manage-subscription-main-div" },
        React.createElement("div", { className: "manage-subscription-container" },
            React.createElement("div", null,
                React.createElement("h1", null, "Manage Subscription"),
                state.account ? (isSelfServiceAccount(state.account) ? (React.createElement("div", null,
                    React.createElement("p", null,
                        "Your subscription is currently ",
                        React.createElement("b", null, "active"),
                        "."),
                    React.createElement("p", null, "If you cancel your subscription, your account will be disabled, and you will no longer be able to access the dashboard."),
                    React.createElement("p", null, "Please note that canceling your subscription will result in a final bill for any billable jobs you\u2019ve created since your last billing statement."),
                    isLoading ? (React.createElement(CircularProgress, { size: "1.2rem", style: { color: '#290e88' } })) : (React.createElement(Button, { onClick: submitCancelSubscription }, "Cancel")))) : (React.createElement("div", null,
                    React.createElement("p", null,
                        "Your account's subscription is managed by the Vouched team. Reach out to ",
                        React.createElement("a", { href: "mailto:support@vouched.id" }, "support"),
                        ' ',
                        "in order to cancel your subscription.")))) : (React.createElement("div", null, "Your account does not have a subscription"))))));
};
